import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { obvStreamedDataSelectors } from 'widgets/obvTile/store/stream/streamSlice';
import { ObvTileConfigState } from 'widgets/obvTile/store/config/ObvTileConfigState';

const { useStreamedDataMessages } = obvStreamedDataSelectors;

export function useObvMessagesInMyPortfolioCapsules(symbol: string) {
    const { config } = useMyPortfolioCapsuleConfigSlice<ObvTileConfigState>();

    return useStreamedDataMessages(symbol, config);
}
